import React from "react";
import "./WhyRight.css";
import school from "../../Assets/vectors/school.svg";
import books from "../../Assets/vectors/books.svg";
import brain from "../../Assets/vectors/brain.svg";
import reading from "../../Assets/reading.png";
import plans from "../../Assets/vectors/plans.svg";
import background from "../../Assets/background_shape_1.svg";

export default function WhyRight() {
  return (
    <div className="grid grid2Fr whyRight">
      <div className="content">
        <h3>Why Us</h3>
        <h1>Our School Is The Right Fit For Your Children</h1>
        <div className="optionContainer">
          <div className="options">
            <img src={brain} alt="" />
            <b>Trained Teachers</b>
          </div>
          <div className="options">
            <img src={school} alt="" />
            <b>Right Educational Environment</b>
          </div>
          <div className="options">
            <img src={books} alt="" />
            <b>We Follow International Teaching Patterns</b>
          </div>
          <div className="options">
            <img src={plans} alt="" />
            <b>We Use Organized Lesson Plans</b>
          </div>
        </div>
      </div>
      <div className="imageContainer">
        <img src={reading} alt="" />
      </div>
    </div>
  );
}
